import { apiClient } from '../../../shared/api/apiClient';

const TENANT_SETTINGS_PATH = '/users/tenant-settings/';

export function fetchTenantSettings() {
  return apiClient.get(TENANT_SETTINGS_PATH);
}
